/**
 * Reusable empty-state card for list screens.
 */
export default function EmptyState({ icon, headline, body, button, onAction, testid }) {
  return (
    <div
      className="bg-white border border-[var(--br)] rounded-2xl p-6 text-center card-sh"
      data-testid={testid || "empty-state"}
    >
      {icon && (
        <div className="flex justify-center mb-3 text-[var(--ac)]">{icon}</div>
      )}
      <div className="text-[16px] font-extrabold text-[var(--tx)] mb-2">{headline}</div>
      <div className="text-[13px] text-[var(--tx2)] leading-snug mb-4">{body}</div>
      {button && onAction && (
        <button
          onClick={onAction}
          data-testid={`${testid || "empty"}-cta`}
          className="bg-[var(--ac)] text-white px-4 py-2.5 rounded-xl font-extrabold text-[13px]"
          style={{ boxShadow: "0 4px 14px rgba(13,110,110,0.22)" }}
        >
          {button}
        </button>
      )}
    </div>
  );
}
